<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import CkeditorWidget from "@/components/widgets/editor.vue";
import axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";

export default {
  page: {
    title: "Form Soal Esai",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    CkeditorWidget,
  },
  data() {
    return {
      title: "Soal Esai",
      items: [
        {
          text: "Master Soal",
          href: "/",
        },
        {
          text: "Form Soal Esai",
          active: true,
        },
      ],
      idKompetensi: this.$route.params.id,
      activeTab: "original", // "original" | "perbaikan"
      formData: {
        soal_text: "",
        soal_image: null,
        versi_soal: "",
        pertanyaan: "",
        jumlah_jawaban: "", // required jika Pilihan Ganda
        tipe: "Text", // Pilihan Ganda | Text
        keywords: [
          {
            keyword: "",
            skor: 0,
          },
        ], // required jika tipe Text
        kategori_idkategori: "",
        jawaban: [],
        timer: 0,
        nomor_urut: 1,
        previewUrl: "",
        approved: false,
        catatan: "",
      },
      kompetensi: {},
      listKategori: [],
      idSoal: this.$route.params.idsoal,
      showModalPreview: false,
      previewImageUrl: "",
      statusReview: "PENDING",
      // data soal original (tab pertama), diambil sebelum kemungkinan ditimpa data perbaikan
      soalOriginalNomorUrut: "",
      soalOriginalVersiSoal: "",
      soalOriginalPertanyaan: "",
      soalOriginalImage: "",
      soalOriginalKeywords: [],
    };
  },
  computed: {
    isVerifikasiCompleted() {
      return ["COMPLETED", "REPAIRED"].includes(this.statusReview);
    },
    verifikasiStatusInfo() {
      const map = {
        PENDING: {
          alertClass: "alert-secondary",
          icon: "fa fa-clock",
          description: "Soal ini belum direview di halaman Review Soal.",
        },
        REVIEWED: {
          alertClass: "alert-info",
          icon: "fa fa-eye",
          description:
            "Soal ini sudah dikirim dari halaman Review Soal dan perlu dilakukan perbaikan pada tab Perbaikan.",
        },
        REVISION: {
          alertClass: "alert-danger",
          icon: "fa fa-pen",
          description:
            "Soal ini ditandai perlu revisi. Silakan lakukan perbaikan pada tab Perbaikan.",
        },
        REPAIRED: {
          alertClass: "alert-primary",
          icon: "fa fa-wrench",
          description: "Soal ini sudah diperbaiki.",
        },
        COMPLETED: {
          alertClass: "alert-success",
          icon: "fa fa-check-circle",
          description:
            "Soal ini sudah selesai diperbaiki. Tab Perbaikan tidak dapat diedit lagi.",
        },
      };
      return map[this.statusReview] || map.PENDING;
    },
  },
  async mounted() {
    Swal.fire({
      title: "Memuat data...",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const tasks = [this.getKategori(), this.getKompetensi()];
    if (this.idSoal) {
      tasks.push(
        this.getData()
          .then(() => this.getPerbaikanSoal())
          .then(() => this.getVerifikasiStatus())
      );
    } else {
      tasks.push(this.getNextNomorUrut());
    }
    await Promise.all(tasks);

    Swal.close();
  },
  methods: {
    async getVerifikasiStatus() {
      const data = await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "review-soal/tools-asesmen/soal/" +
            this.idSoal +
            "/verifikasi",
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data)
        .catch((err) => {
          console.log(err);
          return false;
        });
      if (data) {
        this.formData.approved = data.approved === true;
        this.formData.catatan = data.catatan ?? "";
        this.statusReview = data.status_review ?? "PENDING";
      }
    },
    async getNextNomorUrut() {
      const data = await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "master/kompetensi/" +
            this.idKompetensi +
            "/soal/next-nomor-urut",
          {
            params: {
              tipe: this.formData.tipe,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data)
        .catch((err) => {
          console.log(err);
          return false;
        });
      if (data) {
        this.formData.nomor_urut = data.nomor_urut ?? data;
      }
    },
    async getData() {
      if (this.idSoal) {
        const data = await axios
          .get(
            process.env.VUE_APP_BACKEND_URL_VERSION +
              "master/kompetensi/" +
              this.idKompetensi +
              "/soal/" +
              this.idSoal,
            {
              headers: {
                Authorization: "Bearer " + localStorage.access_token,
                Accept: "Application/json",
              },
            }
          )
          .then((response) => response.data.data)
          .catch((err) => {
            console.log(err);
            return false;
          });
        if (data) {
          this.formData = data;

          // simpan salinan data asli (sebelum kemungkinan ditimpa data perbaikan)
          // untuk ditampilkan di tab "Soal Original"
          const urlBackend = process.env.VUE_APP_BACKEND_URL;
          this.soalOriginalNomorUrut = data.nomor_urut;
          this.soalOriginalVersiSoal = data.versi_soal;
          this.soalOriginalPertanyaan = data.pertanyaan;
          this.soalOriginalImage = data.soal_image ? urlBackend + data.soal_image : "";
          this.soalOriginalKeywords = Array.isArray(data.keywords)
            ? data.keywords.map((k) => ({ keyword: k.keyword, skor: k.skor }))
            : [];
        }
      }
    },
    async getPerbaikanSoal() {
      const data = await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "monitoring-review/tools-asesmen/soal/" +
            this.idSoal +
            "/perbaikan",
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data)
        .catch((err) => {
          console.log(err);
          return false;
        });

      if (data) {
        const urlBackendBase = process.env.VUE_APP_BACKEND_URL;
        this.formData.pertanyaan = data.pertanyaan;
        this.formData.soal_text = data.soal_text;
        this.formData.soal_image = data.soal_image;
        this.formData.previewUrl = data.soal_image
          ? urlBackendBase + data.soal_image
          : "";
        this.formData.jumlah_jawaban = data.jumlah_jawaban;
        this.formData.nomor_urut = data.nomor_urut;
        this.formData.timer = data.timer;
        this.formData.versi_soal = data.versi_soal;

        if (data.keywords) {
          const keywords =
            typeof data.keywords === "string"
              ? JSON.parse(data.keywords)
              : data.keywords;
          if (Array.isArray(keywords) && keywords.length) {
            this.formData.keywords = keywords;
          }
        }
      }
    },
    async searchKategori(search, loading) {
      if (search.length) {
        loading(true);
        this.getKategori(search, loading);
      }
    },
    async getKategori(search = "", loading) {
      const data = await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/kategori/all",
          {
            params: {
              search: search,
              limit: 10,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data);

      if (data) {
        this.listKategori = data;
      }
      if (loading) loading(false);
    },
    async getKompetensi() {
      console.log(this.$route.params.id);
      const data = await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "master/kompetensi/" +
            this.idKompetensi,
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data);

      if (data) {
        this.kompetensi = data;
      }
    },
    save() {
      // Endpoint usulan perbaikan soal, dikelompokkan di prefix monitoring-review -> tools-asesmen (method POST)
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "monitoring-review/tools-asesmen/soal/" +
        this.idSoal +
        "/perbaikan";

      Swal.fire({
        icon: "warning",
        title: "Konfirmasi Perbaikan Soal",
        text: "Yakin akan menyimpan perbaikan untuk soal ini? Simpan pertanyaan dan jawaban versi perbaikan ini pada halaman Monitoring Review.",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Iya, Simpan`,
        denyButtonText: `Tidak`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = await axios({
            url: url,
            method: "post",
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
            data: this.formData,
          })
            .then((response) => response.data.data)
            .catch((error) => {
              console.log(error);
              let err = error.response.data.data;
              Swal.fire({
                icon: "warning",
                title: "Terjadi Kesalahan",
                text: err,
                timer: 3000,
                timerProgressBar: true,
                showCancelButton: false,
                showConfirmButton: false,
              });
              return false;
            });
          if (data) {
            Swal.fire({
              icon: "success",
              title: "Berhasil",
              text: "Usulan perbaikan soal berhasil disimpan",
              timer: 1000,
              timerProgressBar: true,
              showCancelButton: false,
              showConfirmButton: false,
            });
            this.backToList();
          }
        }
      });
    },
    inputFilePhoto() {
      let self = this;
      if ($("#formImage")[0].files[0]) {
        if ($("#formImage")[0].files[0].size < 2242880) {
          $("#uploadLoading").html(
            '<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>'
          );
          var urlres = process.env.VUE_APP_BACKEND_URL;
          var FormData = require("form-data");
          var data = new FormData();
          data.append("file", $("#formImage")[0].files[0]);
          var config = {
            method: "post",
            url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
            data: data,
          };
          axios(config).then(function (response) {
            console.log(response.data.data.path_file);
            var path_file = response.data.data.path_file;
            urlres += path_file;
            $("#uploadLoading").html("");
            $(".image").attr("src", urlres);
            $(".middle").attr("href", urlres);
            self.formData.soal_image = path_file;
            self.formData.previewUrl = urlres;
          });
        } else {
          alert("Max File 2 MB");
        }
      }
    },
    addJawaban() {
      this.formData.keywords.push({
        keyword: "",
        skor: 0,
      });
    },
    async remJawaban(index) {
      if (this.formData.keywords.length == 1) {
        Swal.fire({
          icon: "warning",
          title: "Terjadi Kesalahan",
          text: "Pilihan jawaban tidak boleh kosong!",
        });
        return;
      }
      let proceed = true;
      if (Object.hasOwn(this.formData.keywords[index], "idkeyword")) {
        await Swal.fire({
          icon: "warning",
          title: "Konfirmasi!",
          text: "Apakah Anda Yakin?",
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: `Iya`,
          denyButtonText: `Tidak`,
        }).then((result) => {
          if (result.isConfirmed) {
            proceed = true;
          } else {
            proceed = false;
          }
        });
      }
      if (proceed) {
        this.formData.keywords.splice(index, 1);
      }
    },
    backToList() {
      return this.$router.push({
        name: "monitoring-review-text",
        params: { id: this.idKompetensi },
      });
    },
    isChecked(row) {
      return row.skor == 1;
    },
    previewImage() {
      this.previewImageUrl = this.formData.previewUrl;
      this.showModalPreview = true;
    },
    previewOriginalImage() {
      this.previewImageUrl = this.soalOriginalImage;
      this.showModalPreview = true;
    },
    deleteSoalImage() {
      Swal.fire({
        icon: "warning",
        title: "Perhatian!",
        text: "Apakah Anda yakin menghapus gambar ini ?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Iya`,
        denyButtonText: `Tidak`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.formData.previewUrl = "";
          this.formData.soal_image = "";
        }
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 d-flex justify-content-between">
                <div>
                  <div class="card-title">Form Soal Esai</div>
                  <div>
                    <span class="font-weight-bold">Kompetensi :</span>
                    <br />
                    <strong>{{ kompetensi?.nama_kompetensi || "-" }}</strong>
                  </div>
                  <div>
                    <span class="font-weight-bold">Level Proficiency :</span>
                    <br />
                    <strong>
                      {{ kompetensi?.level_kompetensi?.nama_level || "-" }}
                    </strong>
                  </div>
                </div>
                <div class="d-flex align-items-start gap-2"></div>
              </div>
              <div class="col-12">
                <hr />
              </div>
              <div class="col-12">
                <ul class="nav mb-3 mym-inner-tabs">
                  <li class="nav-item">
                    <button
                      type="button"
                      class="nav-link"
                      :class="{ active: activeTab === 'original' }"
                      @click="activeTab = 'original'"
                    >
                      <i class="fa fa-file-alt me-1"></i>
                      Soal Original
                    </button>
                  </li>
                  <li class="nav-item">
                    <button
                      type="button"
                      class="nav-link"
                      :class="{ active: activeTab === 'perbaikan' }"
                      @click="activeTab = 'perbaikan'"
                    >
                      <i class="fa fa-edit me-1"></i>
                      Perbaikan
                    </button>
                  </li>
                </ul>
              </div>

              <!-- TAB: SOAL ORIGINAL -->
              <div class="col-12" v-if="activeTab === 'original'">
                <div class="row mb-3">
                  <div class="col-6 mb-2">
                    <div class="fw-semibold">Nomor Urut</div>
                    <div>{{ soalOriginalNomorUrut || "-" }}</div>
                  </div>
                  <div class="col-6 mb-2">
                    <div class="fw-semibold mb-1">Gambar</div>
                    <div class="container-image" v-if="soalOriginalImage">
                      <img :src="soalOriginalImage" class="image" />
                      <div
                        class="middle d-flex flex-column gap-2 align-items-center justify-content-center"
                      >
                        <button
                          class="btn btn-success btn-sm"
                          @click="previewOriginalImage"
                        >
                          <i class="fa fa-search"></i> Preview
                        </button>
                      </div>
                    </div>
                    <div v-else>-</div>
                  </div>
                </div>

                <div class="mb-3">
                  <div class="fw-semibold">Versi Soal</div>
                  <div>{{ soalOriginalVersiSoal || "-" }}</div>
                </div>

                <div class="mb-3">
                  <div class="fw-semibold mb-1">Pertanyaan</div>
                  <div v-html="soalOriginalPertanyaan"></div>
                </div>

                <table class="table table-striped table-condensed mb-0">
                  <thead class="text-center bg-dark text-white">
                    <tr>
                      <th>Keyword</th>
                      <th width="100px">Poin</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(keyword, index) in soalOriginalKeywords"
                      :key="index"
                    >
                      <td>{{ keyword.keyword || "-" }}</td>
                      <td class="text-center">{{ keyword.skor ?? "-" }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- TAB: PERBAIKAN -->
              <div class="col-12" v-if="activeTab === 'perbaikan'">
                <div v-if="isVerifikasiCompleted" class="alert alert-success">
                  <i class="mdi mdi-lock-outline me-1"></i>
                  Soal ini sudah <strong>{{ statusReview }}</strong> dan tidak dapat diedit lagi.
                </div>
                <div class="row mb-2">
                  <div
                    class="col-6 mb-2"
                    v-if="
                      kompetensi?.level_kompetensi?.idlevel_kompetensi == 3 ||
                      kompetensi?.level_kompetensi?.idlevel_kompetensi == 4
                    "
                  >
                    <div class="form group">
                      <label for="kategori_idkategori">Studi Kasus</label>
                      <v-select
                        id="form_kategori"
                        class="style-chooser"
                        :options="listKategori"
                        :reduce="(kategori) => kategori.idkategori"
                        label="kategori"
                        v-model="formData.kategori_idkategori"
                        placeholder="Pilih Kategori"
                        :disabled="isVerifikasiCompleted"
                        @search="searchKategori"
                      />
                    </div>
                  </div>
                  <div class="col-6 mb-1">
                    <div class="form group">
                      <label for="kategori_idkategori">Nomor Urut</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Nomor urut"
                        v-model="formData.nomor_urut"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="col-6 mb-1">
                    <div class="form group">
                      <label for="formImage" class="form-label">
                        Upload Gambar
                      </label>
                      <input
                        class="form-control"
                        type="file"
                        id="formImage"
                        :disabled="isVerifikasiCompleted"
                        v-on:change="inputFilePhoto()"
                      />
                      <div
                        class="respond-input-file float-left"
                        id="uploadLoading"
                      ></div>
                      <small class="float-right" style="color: red">
                        Max File 2 MB
                      </small>
                    </div>
                    <div class="container-image" v-if="formData.previewUrl">
                      <img :src="formData.previewUrl" class="image" />
                      <div
                        class="middle d-flex flex-column gap-2 align-items-center justify-content-center"
                      >
                        <button
                          class="btn btn-success btn-sm"
                          @click="previewImage"
                        >
                          <i class="fa fa-search"></i> Preview
                        </button>
                        <button
                          v-if="!isVerifikasiCompleted"
                          class="btn btn-danger btn-sm"
                          @click="deleteSoalImage"
                        >
                          <i class="fa fa-trash"></i> Hapus
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mb-2 form-group">
                    <label for="versi_soal">Versi Soal</label>
                    <input
                      type="text"
                      id="versi_soal"
                      class="form-control"
                      placeholder="Versi Soal"
                      v-model="formData.versi_soal"
                      :disabled="isVerifikasiCompleted"
                    />
                  </div>
                  <div class="col-12 mb-2 form-group">
                    <label for="pertanyaan">Pertanyaan</label>
                    <CkeditorWidget v-model="formData.pertanyaan" :disabled="isVerifikasiCompleted" />
                  </div>
                  <div class="col-12 mb-2">
                    <table class="table table-striped table-condensed">
                      <thead class="text-center bg-dark text-white">
                        <tr>
                          <th width="10px"></th>
                          <th>Keyword</th>
                          <th width="100px">Poin</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(keyword, index) in formData.keywords"
                          :key="index"
                        >
                          <td>
                            <button
                              class="btn btn-danger btn-sm"
                              :disabled="isVerifikasiCompleted"
                              @click="remJawaban(index)"
                            >
                              <i class="fa fa-trash"></i>
                            </button>
                          </td>
                          <td>
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              placeholder="Keywords"
                              v-model="keyword.keyword"
                              :disabled="isVerifikasiCompleted"
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              min="0"
                              class="form-control form-control-sm"
                              placeholder="Poin"
                              v-model="keyword.skor"
                              :disabled="isVerifikasiCompleted"
                            />
                          </td>
                        </tr>
                        <tr v-if="!isVerifikasiCompleted">
                          <td colspan="4">
                            <div class="d-grid gap-2">
                              <button
                                class="btn btn-success btn-sm"
                                type="button"
                                @click="addJawaban()"
                              >
                                <i class="fa fa-plus me-2"></i> Tambah
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <div class="row">
      <div class="col-lg-12">
        <div
          class="card border"
          :class="formData.approved ? 'border-success' : 'border-warning'"
        >
          <div class="card-body bg-light">
            <h6
              class="card-title border-bottom pb-2 mb-3"
              :class="formData.approved ? 'text-success' : 'text-warning'"
            >
              <i class="mdi mdi-shield-check-outline me-1"></i>
              Verifikasi Soal
              <small class="text-muted fw-normal ms-2">(readonly)</small>
            </h6>

            <div
              class="alert d-flex align-items-center gap-2 mb-3"
              :class="verifikasiStatusInfo.alertClass"
            >
              <i :class="verifikasiStatusInfo.icon" class="font-size-18"></i>
              <div>
                <strong>{{ statusReview }}</strong> —
                {{ verifikasiStatusInfo.description }}
              </div>
            </div>

            <!-- APPROVED -->
            <div class="d-flex align-items-center gap-2 mb-3">
              <label class="form-label fw-semibold mb-0"> Approved </label>
              <div class="form-check form-switch mb-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="approved"
                  :checked="formData.approved === true"
                  disabled
                />
              </div>
            </div>

            <!-- CATATAN -->
            <div class="mb-0">
              <label class="form-label fw-semibold mb-1">
                Catatan Verifikasi
              </label>
              <textarea
                class="form-control"
                :class="formData.approved ? 'border-success' : 'border-warning'"
                rows="3"
                v-model="formData.catatan"
                disabled
                placeholder="Belum ada catatan verifikasi."
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-lg-12">
        <div class="d-flex justify-content-end gap-2">
          <button class="btn btn-secondary" @click="backToList()">
            <i class="fa fa-arrow-left me-1"></i>
            Kembali
          </button>
          <button
            v-if="activeTab === 'perbaikan' && !isVerifikasiCompleted"
            class="btn btn-primary"
            @click="save()"
          >
            <i class="fa fa-save me-1"></i>
            Verifikasi
          </button>
        </div>
      </div>
    </div>
  </Layout>

  <b-modal
    v-model="showModalPreview"
    title="Preview Gambar"
    centered
    hide-footer
    size="xl"
  >
    <div class="text-center" style="position: relative; width: 100%">
      <img :src="previewImageUrl" class="image" />
    </div>
  </b-modal>
</template>
